export const ROW_CLASS_INELIGIBLE = 'credit-reversal-row-ineligible';
export const PENDING_CREDIT_REVERSAL_CAP = 3;

export const CREDIT_LIKE_TYPES = [
  'credit',
  'gift_card',
  'le_points',
  'le_points_airport_transfer',
  'le_points_discounted_insurance',
  'le_points_hotel_upgrade',
  'le_points_lounge_pass',
  'manual',
  'promo',
];

export interface ReversalReason {
  label: string;
  value: string;
}

export const REVERSAL_REASONS: Array<ReversalReason> = [
  { label: 'Accidental Credit Conversion (Within Policy)', value: 'accidental_credit_conversion_within_policy' },
  { label: 'Agent Error', value: 'agent_error' },
  { label: 'Credit Rebooking Cancelled (Within Policy)', value: 'credit_rebooking_cancelled_within_policy' },
  { label: 'Downgrade Refund (Within Policy)', value: 'downgrade_refund_within_policy' },
  { label: 'Failed to Apply Credit (TL Approved)', value: 'failed_to_apply_credit_tl_approved' },
  { label: 'Flight Refund', value: 'flight_refund' },
  { label: 'Force Majeure', value: 'force_majeure' },
  { label: 'Fraud', value: 'fraud' },
  { label: 'Goodwill Gesture (TL Approved)', value: 'goodwill_gesture_tl_approved' },
  { label: 'LuxPlus+ Subscription Refund', value: 'luxplus_subscription_refund' },
  { label: 'Negative Feedback - TL Approved GWG', value: 'negative_feedback_tl_approved_gwg' },
  { label: 'Other', value: 'other' },
  { label: 'Overcharged via Invoice', value: 'overcharged_via_invoice' },
  { label: 'Rebooking & Applying Promo (Within Policy)', value: 'rebooking_applying_promo_within_policy' },
  { label: 'Refund 50%', value: 'refund_50' },
  { label: 'Refund 70%', value: 'refund_70' },
  { label: 'Refund 80%', value: 'refund_80' },
  { label: 'Refund 90%', value: 'refund_90' },
  { label: 'Refund 90% Retain 10% Credit', value: 'refund_90_retain_10_credit' },
  { label: 'Rejected Booking/Hotel Closure', value: 'rejected_booking_hotel_closure' },
  { label: 'Social Media/ACC/Fair Trading Escalation', value: 'social_media_acc_fair_trading_escalation' },
  { label: 'Tech Error or Mapping Error', value: 'tech_error_or_mapping_error' },
  { label: 'Tours - Approved by DMC', value: 'tours_approved_by_dmc' },
  { label: 'Wholesale Rate', value: 'wholesale_rate' },
  { label: 'Within Refund Policy', value: 'within_refund_policy' },
];

export const LOCKED_PARTIAL_REFUND_REASONS = new Set([
  'refund_50',
  'refund_70',
  'refund_80',
  'refund_90',
  'refund_90_retain_10_credit',
]);

// Percentages applied to credit deduction to derive cash reversed.
export const REFUND_PERCENTAGE_MAP: Record<string, number> = {
  refund_50: 0.5,
  refund_70: 0.7,
  refund_80: 0.8,
  refund_90: 0.9,
};
